import React from 'react';
import PropTypes from 'prop-types';
import { AlertDialog, Callout, Flex, Link, Text } from '@homeexchange/design';
import i18n from '../../../i18n';

const PauseDialog = ({ isOpen, onConfirm, onDismiss }) => (
    <AlertDialog
        title={i18n.t('collection:modal.applicationCollection.applicationPause.title')}
        confirmActionText={i18n.t('collection:global.pauseApplication')}
        dismissActionText={i18n.t('collection:global.continueApplication')}
        isOpen={isOpen}
        onConfirmAction={onConfirm}
        onDismissAction={onDismiss}
    >
        <Flex>
            <Text>{i18n.t('collection:modal.applicationCollection.applicationPause.body')}</Text>

            <Callout hasIcon size="small" status="info">
                <Text isBold>
                    {i18n.t('collection:funnel.applicationCollection.part.applicationPause.calloutTitle')}
                </Text>
                <Text>
                    {i18n.t('collection:funnel.applicationCollection.part.applicationPause.calloutBody')}
                </Text>
                <Link href={i18n.t('collection:contact-page-mail-link-collection')} target="_blank">
                    {i18n.t('collection:global.contactus')}
                </Link>
            </Callout>
        </Flex>
    </AlertDialog>
);

PauseDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired
};

export default PauseDialog;
